module.exports = __webpack_public_path__ + "img/ergLogo6@2x.1f86dc43.jpg";